/**
 * 安全地把金額輸入字串（可能含 +、-、*、/）評估為整數。
 * 只允許數字與四則運算符號，用 Function() 計算，結果取整數。
 * 返回 null 表示無效（空字串、非數字、負數）。
 */
export function evalAmount(expr: string): number | null {
  const s = expr.trim()
  if (!s) return null
  // 只允許數字、空白、加減乘除、小數點、括號
  if (!/^[\d\s+\-*/().]+$/.test(s)) return null
  try {
    // eslint-disable-next-line no-new-func
    const result = Function('"use strict"; return (' + s + ')')() as unknown
    if (typeof result !== 'number' || !isFinite(result) || result < 0) return null
    return Math.round(result)
  } catch {
    return null
  }
}

/** 判斷字串是否為複合運算式（含運算符） */
export function isExpression(expr: string): boolean {
  return /[+\-*/]/.test(expr.trim())
}
